/**
 * Customers API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCustomer,
  deleteCustomer,
  getCustomerById,
  getCustomers,
  permanentDeleteCustomer,
  restoreCustomer,
  updateCustomer,
} from "../generated/customers/customers";

import { wrapListMethod, wrapMethod } from "./utils";

export const customers = {
  /** @see createCustomer */
  create: wrapMethod(createCustomer),

  /** @see getCustomers */
  list: wrapListMethod(getCustomers),

  /** @see getCustomerById */
  get: wrapMethod(getCustomerById),

  /** @see updateCustomer */
  update: wrapMethod(updateCustomer),

  /** @see deleteCustomer */
  delete: wrapMethod(deleteCustomer),

  /** @see restoreCustomer */
  restoreCustomer: wrapMethod(restoreCustomer),

  /** @see permanentDeleteCustomer */
  permanentDeleteCustomer: wrapMethod(permanentDeleteCustomer),
} as const;

export type CustomersApi = typeof customers;
